<template>
  <div class="carousel_wrap">
    <el-carousel height="35vw" loop arrow="hover" class="hidden-xs-only">
      <el-carousel-item v-for="(item, index) in imgList" :key="index" @click.native="handleArticleInfo(item.url)">
        <img :src="item.src" alt="" class="img_item"/>
      </el-carousel-item>
    </el-carousel>
    <el-carousel height="45vw" loop arrow="hover" class="hidden-sm-and-up">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import {getImgList} from "@/api/home";
import {ImageTypeEnum} from "@/enums/imageTypeEnum";

export default {
  data() {
    return {
      //banner图数组
      imgList: []
    }
  },
  created() {
    this.getBannerList();
  },
  methods: {
    //获取图片信息
    getBannerList() {
      // 调用后端接口
      getImgList(ImageTypeEnum.HOME_BANNER.value).then(res => {
          this.imgList = res.data;
        }
      )
    },
    //点击banner图跳转文章详情链接
    handleArticleInfo(url){
      if(url){
        this.$router.push(url);
      }

    }
  }
}
</script>

<style lang="scss">
.carousel_wrap {
  position: relative;
  .el-carousel__item {
    img {
      // 让图片宽度填满容器
      width: 100%;
      // 让图片高度自动适应，以保持宽高比
      height: 35vw;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        height: 45vw;
      }
    }
  }
}
</style>